<div class="dialog-header">
  <div class="header-title"><span style="font-size: 125%;">CSV Export/Import</span></div>

  <button mat-button class="close-button-container" mat-dialog-close disableRipple="true">
    <mat-icon>clear</mat-icon>
  </button>
</div>

<div class="middle-content timesheet-dialog">
  <form #csvForm="ngForm">
    <div class="form-block">
      <div class="form-row">
        <div class="icon-block">
          <mat-icon>person</mat-icon>
        </div>
        <div class="field-block">
          <p-multiSelect [ngModelOptions]="{standalone: true}"
                         [options]="users"
                         [(ngModel)]="selectedUsers"
                         optionLabel="name"
                         defaultLabel="Users"
                         appendTo="body"
                         panelStyleClass="vacation-multiselect"
                         (onPanelShow)="disableClose()" (onPanelHide)="enableClose()">
          </p-multiSelect>
        </div>
      </div>

      <div class="form-row">
        <div class="label-block">
          From:
        </div>
        <div class="field-block calendar-block">
          <p-calendar [(ngModel)]="startDate" view="date" [tabindex]="-1" type="date" readonly="readonly"
                      placeholder="Date"
                      [touchUI]="true" name="startDate" [showIcon]="true" [ngModelOptions]="{standalone: true}"
                      (onShow)="disableClose()" (onClose)="enableClose()" [readonlyInput]="false"
                      [showOnFocus]="false">
          </p-calendar>
        </div>
      </div>

      <div class="form-row">
        <div class="label-block">
          To:
        </div>
        <div class="field-block calendar-block">
          <p-calendar [(ngModel)]="endDate" view="date" [tabindex]="-1" type="date" readonly="readonly" placeholder="Date"
                      [touchUI]="true" name="startDate" [showIcon]="true" [ngModelOptions]="{standalone: true}"
                      (onShow)="disableClose()" (onClose)="enableClose()" [readonlyInput]="false"
                      [showOnFocus]="false">
          </p-calendar>
        </div>
      </div>

      <div class="export-btn-block">
        <button mat-button class="export-btn" (click)="exportCsv()"
                [disabled]="selectedUsers.length === 0 || !startDate || !endDate"
                [ngClass]="{'disabled-button': selectedUsers.length === 0 || !startDate || !endDate}">
          Export CSV
        </button>
      </div>

      <div class="drop-zone"
           [ngClass]="{'dragging': isDragging}"
           (dragover)="onDragOver($event)"
           (dragleave)="onDragLeave($event)"
           (drop)="onDrop($event)"
           (click)="triggerFileInput()">
        <mat-icon class="upload-icon">cloud_upload</mat-icon>
        <div class="drop-text">Drop CSV files here or</div>
        <span class="file-select-label">Browse Files</span>
        <input #fileInput type="file" multiple accept=".csv" (change)="onFileSelect($event)" hidden>
      </div>

      <div class="files-list" *ngIf="fileStatuses.length > 0">
        <div class="files-header">
          <span>Files</span>
          <button mat-button class="clear-btn" (click)="clearFiles()">Clear All</button>
        </div>

        <div class="file-item" *ngFor="let fileStatus of fileStatuses">
          <div class="file-row">
            <div class="file-info">
              <mat-icon class="file-icon">insert_drive_file</mat-icon>
              <span class="file-name">{{fileStatus.file.name}}</span>
            </div>

            <div class="file-status">
              <mat-icon *ngIf="fileStatus.status === 'pending'" class="status-icon pending">schedule</mat-icon>
              <lib-mini-progress-spinner *ngIf="fileStatus.status === 'uploading'"></lib-mini-progress-spinner>
              <mat-icon *ngIf="fileStatus.status === 'success'" class="status-icon success">check_circle</mat-icon>
              <mat-icon *ngIf="fileStatus.status === 'error'" class="status-icon error">error</mat-icon>
              <button mat-icon-button class="remove-btn" (click)="removeFile(fileStatus)"
                      *ngIf="fileStatus.status !== 'uploading'">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          </div>
          <div class="error-message" *ngIf="fileStatus.status === 'error' && fileStatus.error">
            {{fileStatus.error}}
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
